var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6784FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.143 8.584c0-.953.796-1.727 1.777-1.727h10.16c.98 0 1.777.774 1.777 1.727v6.832c0 .953-.796 1.727-1.778 1.727H6.92c-.981 0-1.777-.774-1.777-1.728zm1.777-1.31c-.744 0-1.348.588-1.348 1.31v6.832c0 .723.605 1.31 1.348 1.31h10.16c.743 0 1.347-.588 1.347-1.31V8.584c0-.723-.604-1.31-1.348-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.437a2.563 2.563 0 1 0 0 5.126a2.563 2.563 0 0 0 0-5.126M9 12a3 3 0 1 1 6 0a3 3 0 0 1-6 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.786 11.143c.126 0 .214.103.214.23v1.056h1.055c.128 0 .23.087.23.214s-.102.214-.23.214h-1.484v-1.484c0-.127.088-.23.215-.23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.c1114b8c5c025fa5df6c16cd171b977f.svg";
export { ForwardRef as ReactComponent };